import { render, staticRenderFns } from "./SingleGame.vue?vue&type=template&id=4660da84&scoped=true&"
import script from "./SingleGame.vue?vue&type=script&lang=js&"
export * from "./SingleGame.vue?vue&type=script&lang=js&"
import style0 from "./SingleGame.vue?vue&type=style&index=0&id=4660da84&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4660da84",
  null
  
)

export default component.exports